import { useState, useContext } from "react";
import { Form, Button } from "react-bootstrap";
import { Navigate, useNavigate } from "react-router-dom";
import UserContext from "../context/UserContext";
import { Notyf } from "notyf";

export default function AddProduct({ fetchData }) {
  const notyf = new Notyf();
  const navigate = useNavigate();
  const { user } = useContext(UserContext);

  // input states
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [price, setPrice] = useState("");
  const [imageUrl, setImageUrl] = useState(""); // New state for image URL
  const [category, setCategory] = useState(""); // New state for category
  const [isNew, setIsNew] = useState(false); // New state for isNew
  const [recommended, setRecommended] = useState(false); // New state for recommended

  // Create product function
  function createProduct(e) {
    e.preventDefault();

    let token = localStorage.getItem("token");

    fetch(`${process.env.REACT_APP_API_BASE_URL}/products/`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({
        name: name,
        description: description,
        price: price,
        imageUrl: imageUrl, // Include imageUrl in the request body
        category: category, // Include category in the request body
        isNew: isNew, // Include isNew in the request body
        recommended: recommended, // Include recommended in the request body
      }),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data) {
          setName("");
          setDescription("");
          setPrice(0);
          setImageUrl(""); // Clear image URL input
          setCategory(""); // Clear category
          setIsNew(false); // Reset isNew to false
          setRecommended(false); // Reset recommended to false
          notyf.success("Product Added");
          fetchData(); // Refresh product list
          navigate("/products");
        } else {
          notyf.error("Error: Something Went Wrong.");
        }
      });
  }

  return user.isAdmin === true ? (
    <>
      <h1 className="my-5 text-center">Add Product</h1>
      <Form onSubmit={(e) => createProduct(e)}>
        <Form.Group>
          <Form.Label>Name:</Form.Label>
          <Form.Control
            type="text"
            placeholder="Enter Name"
            required
            value={name}
            onChange={(e) => setName(e.target.value)}
          />
        </Form.Group>
        <Form.Group>
          <Form.Label>Description:</Form.Label>
          <Form.Control
            type="text"
            placeholder="Enter Description"
            required
            value={description}
            onChange={(e) => setDescription(e.target.value)}
          />
        </Form.Group>
        <Form.Group>
          <Form.Label>Price:</Form.Label>
          <Form.Control
            type="number"
            placeholder="Enter Price"
            required
            value={price}
            onChange={(e) => setPrice(e.target.value)}
          />
        </Form.Group>
        <Form.Group>
          <Form.Label>Image URL:</Form.Label>
          <Form.Control
            type="text"
            placeholder="Enter Image URL"
            required
            value={imageUrl}
            onChange={(e) => setImageUrl(e.target.value)}
          />
        </Form.Group>

        {/* Category Dropdown */}
        <Form.Group>
          <Form.Label>Category:</Form.Label>
          <Form.Control
            as="select"
            value={category}
            onChange={(e) => setCategory(e.target.value)}
            required
          >
            <option value="">Select Category</option>
            <option value="Cakes & Cupcakes">Cakes & Cupcakes</option>
            <option value="Cookies & Bars">Cookies & Bars</option>
            <option value="Pies & Tarts">Pies & Tarts</option>
            <option value="Pastries & Croissants">Pastries & Croissants</option>
            <option value="Cheesecakes">Cheesecakes</option>
            <option value="Vegan & Gluten-Free Desserts">
              Vegan & Gluten-Free Desserts
            </option>
          </Form.Control>
        </Form.Group>

        {/* New Product Checkbox */}
        <Form.Group>
          <Form.Check
            type="checkbox"
            label="Is New"
            checked={isNew}
            onChange={(e) => setIsNew(e.target.checked)}
          />
        </Form.Group>

        {/* Recommended Checkbox */}
        <Form.Group>
          <Form.Check
            type="checkbox"
            label="Recommended"
            checked={recommended}
            onChange={(e) => setRecommended(e.target.checked)}
          />
        </Form.Group>

        <Button variant="primary" type="submit" className="my-5">
          Submit
        </Button>
      </Form>
    </>
  ) : (
    <Navigate to="/products" />
  );
}
